import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, InputAdornment, TextField, Typography,Tooltip} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import {  PageLoader } from "../../../shared_elements";
import { useSnackbar } from "notistack";
import { Autocomplete } from "@material-ui/lab";
import { regexConstants } from "../../../../constants/regEx";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";
import InfoIcon from '@material-ui/icons/Info';
import { gaTelesisInstance, jetStreamInstance, titanAviInstance } from "../../../../shared/components";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";

const AddEditSvEvents = ({ params, toggleModalFn, addEditSvEvents, modeType, getResponseBack }) => {
    const [data, setData] = useState(addEditSvEvents?.data);
    const [error, setError] = useState({ modal: false, data: null });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [categoryInfo, SetCategoryInfo] = useState([]);
    const [aircraftTypesInfo, setAircraftTypesInfo] = useState([]);
    const [engineTypesInfo, setEngineTypesInfo] = useState([]);
    const [apuTypesInfo, setApuTypesInfo] = useState([]);
    const [pltConstants, setPltConstants] = useState([])

    useEffect(() => {
        getPltConstants();
        if (modeType === 'add' || modeType === 'edit') {
            getcategory();
            getAircraftType();
            getEngineType();
            getApuType();
        }
    }, []);

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value })
    }
    const getPltConstants = () => {
        globalPostService('console/get-constants/', { constant_types: ['asset_type'] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setPltConstants(response.data.data)
                }
            })
    }

    const getAircraftType = () => {
        globalGetService(`config-data/aircraft-type/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setAircraftTypesInfo(response?.data?.data);
                }
            })
    }

    const getEngineType = () => {
        globalGetService(`config-data/engine-type/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setEngineTypesInfo(response?.data?.data);
                }
            })
    }

    const getApuType = () => {
        globalGetService(`config-data/apu-type/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setApuTypesInfo(response?.data?.data);
                }
            })
    }

    const getcategory = () => {
        globalGetService(`config-data/categories/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let categoryInfo = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        categoryInfo.push({ id: item?.id, name: item?.name })
                    });
                    SetCategoryInfo(categoryInfo);
                }
            })
    }

    const isDataChanged = () => {
        const originalData = addEditSvEvents?.data || {};
        return (
            data?.name !== originalData?.name ||
            data?.category?.id !== originalData?.category?.id ||
            data?.hours !== originalData?.hours ||
            data?.cycles !== originalData?.cycles ||
            data?.months !== originalData?.months ||
            data?.days !== originalData?.days ||
            data?.asset_type?.value !== originalData?.asset_type?.value ||
            data?.remarks !== originalData?.remarks ||
            data?.year !== originalData?.year ||
            data?.cost !== originalData?.cost ||
            data.is_llp_event !== originalData?.is_llp_event ||
            data.ground_time !== originalData.ground_time ||
            data?.escalation !== originalData?.escalation ||
            (data?.show_in_ops ?? true) !== (originalData?.show_in_ops ?? true) ||
            JSON.stringify(data?.engine_type?.map(a=>a.id).sort()) !== JSON.stringify((originalData?.engine_type || []).map(a=>a.id).sort())||
            JSON.stringify(data?.apu_type?.map(a=>a.id).sort()) !== JSON.stringify((originalData?.apu_type || []).map(a=>a.id).sort())||
            JSON.stringify(data?.aircraft_type?.map(a=>a.id).sort()) !== JSON.stringify((originalData?.aircraft_type || []).map(a=>a.id).sort()));
    };



    const onAddEditSvEvents = () => {
        let validationInputs = {
            name: data?.name?.trim() ? '' : 'Please enter SV Events Name',
            asset_type: data?.asset_type ? '' : "Please select Asset Type",
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, data);
            payload = {
                id: payload?.id ? payload?.id : null,
                name: payload?.name ? payload?.name : null,
                category: payload?.category ? payload?.category : null,
                hours: payload?.is_llp_event ? null :payload?.hours ? parseFloat(payload?.hours) : null,
                cycles: payload?.is_llp_event ? null : payload?.cycles ? parseFloat(payload?.cycles) : null,
                months: payload?.is_llp_event ? null : payload?.months ? parseFloat(payload?.months) : null,
                days: payload?.is_llp_event ? null : payload?.days ? parseFloat(payload?.days) : null,
                escalation: payload?.escalation ? parseFloat(payload?.escalation) : null,
                year: payload?.is_llp_event ? null : payload?.year ? payload?.year : null,
                cost:  payload?.is_llp_event ? null : payload?.cost ? parseFloat(payload?.cost) : null,
                asset_type: payload?.asset_type ? payload?.asset_type : null,
                remarks: payload?.remarks ? payload?.remarks : null,
                aircraft_type: data?.asset_type?.value === 1 ? data?.aircraft_type?.length > 0 ? data?.aircraft_type?.map(ele => ele.id) : [] : [],
                engine_type: data?.asset_type?.value === 2 ? data?.engine_type?.length > 0 ? data?.engine_type?.map(engine => engine.id) : [] : [],
                apu_type: data?.asset_type?.value === 3 ? data?.apu_type?.length > 0 ? data?.apu_type?.map(apu => apu.id) : [] : [],
                is_llp_event: payload?.is_llp_event && data?.asset_type?.value === 2 ? payload?.is_llp_event : false,
                ground_time:payload?.is_llp_event ? null : payload.ground_time ? payload.ground_time : null,
            }
            if (titanAviInstance) {
                payload = {
                    ...payload,
                    show_in_ops: data?.show_in_ops ?? false
                };
            }

            const apiUrl = data?.id ? `config-data/sv-events/bulk-update/` : `config-data/sv-events/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            debugger
            apiMethod(apiUrl, [payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Shop Visit Events Updated Successfully' : 'Shop Visit Events Added Successfully',
                            page_title: 'Config Data : Shop Visit Events',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details })
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Shop Visit Events Updation Failed' : 'Shop Visit Events Added Failed',
                            page_title: 'Config Data : Shop Visit Events',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }
    return (
        <>
            <Dialog open={true} className='console-management-modal' maxWidth="md" >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit ' : modeType === 'view' ? 'View' : 'Add '} Shop Visit Event
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={6}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    disabled={modeType === 'view'}
                                    required={modeType !== 'view'}
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 150 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Autocomplete
                                    getOptionLabel={option => option?.label}
                                    options={pltConstants?.filter(optionItem => optionItem?.type === 'asset_type' && (jetStreamInstance || optionItem?.value !== 10)  && (!gaTelesisInstance || [1, 2, 3, 4].includes(optionItem?.value)))}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="asset_type"
                                    disabled={modeType === 'view'}
                                    value={data?.asset_type || null}
                                    disableClearable={true}
                                    onFocus={() => setError({ ...error, asset_type: '' })}
                                    onChange={(e, value) => { onFieldChange('asset_type', value); }}
                                    renderInput={params => <TextField placeholder={'Please select Asset Type'}  {...params} label={'Asset Type'} error={error?.asset_type || ''} helperText={error?.asset_type || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            {data?.asset_type?.value === 1 ?
                                <Grid item md={12} >
                                    <Autocomplete
                                        disableCloseOnSelect
                                        options={aircraftTypesInfo}
                                        multiple={true}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        getOptionLabel={option => option.name}
                                        value={data?.aircraft_type || []}
                                        onChange={(e, value) => onFieldChange('aircraft_type', value)}
                                        renderInput={params =>
                                            <TextField {...params} name='aircraft_type' label='Aircraft Types'  placeholder={'Please select Aircraft Type'} fullWidth size='small' InputLabelProps={{ shrink: true }} margin="normal" variant='outlined' />
                                        }
                                        disabled={modeType === 'view'}
                                    />
                                </Grid>
                                : null}
                            {data?.asset_type?.value === 2 ?
                                <Grid item md={12} >
                                    <Autocomplete
                                        disableCloseOnSelect
                                        options={engineTypesInfo}
                                        multiple={true}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        getOptionLabel={option => option.name}
                                        value={data?.engine_type || []}
                                        onChange={(e, value) => onFieldChange('engine_type', value)}
                                        renderInput={params => <TextField {...params} name='engine_type' label='Engine Types' placeholder={'Please select Engine Type'} fullWidth size='small' InputLabelProps={{ shrink: true }} margin="normal" variant='outlined' /> }
                                        disabled={modeType === 'view'}
                                    />
                                </Grid>
                                : null}  
                            {data?.asset_type?.value === 3 ?
                                <Grid item md={12} >
                                    <Autocomplete
                                        disableCloseOnSelect
                                        options={apuTypesInfo}
                                        multiple={true}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        getOptionLabel={option => option.name}
                                        value={data?.apu_type || []}
                                        onChange={(e, value) => onFieldChange('apu_type', value)}
                                        renderInput={params => <TextField {...params} name='apu_type' label='APU Types' placeholder={'Please select APU Type'} fullWidth size='small' InputLabelProps={{ shrink: true }} margin="normal" variant='outlined' />}
                                        disabled={modeType === 'view'}
                                    />
                                </Grid>
                                : null}
                            {data?.asset_type?.value === 2 ?
                                <Grid item md={12}>
                                    <FormControlLabel control={<Checkbox checked={data?.is_llp_event} onChange={(e) => onFieldChange('is_llp_event', e.target.checked)} name="isllpevent" color="primary" size="small" />} label="Is LLP Event" />
                                </Grid> : null}
                                <Grid item md={12} style={{padding:'0px',marginTop:'20px'}}> 
                                    <Typography variant="subtitle2" style={{ fontWeight: 700, padding:'0px 5px',lineHeight:0.2 , fontSize:'12px'}} > INTERVAL : </Typography>
                                </Grid>
                            {!data?.is_llp_event ? <>
                                <Grid item md={3}>
                                    <TextField
                                        name='hours'
                                        label='Hours'
                                        disabled={modeType === 'view'}
                                        value={data?.hours || ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ maxLength: 10 }}
                                        onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('hours', e.target.value) : e.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                    />
                                </Grid>
                                <Grid item md={3}>
                                    <TextField
                                        name='cycles'
                                        label='Cycles'
                                        disabled={modeType === 'view'}
                                        value={data?.cycles || ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ maxLength: 10 }}
                                        onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('cycles', e.target.value) : e.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                    />
                                </Grid>
                                <Grid item md={3}>
                                    <TextField
                                        name='months'
                                        label='Months'
                                        disabled={modeType === 'view'}
                                        value={data?.months || ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ maxLength: 5 }}
                                        onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('months', e.target.value) : e.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                    />
                                </Grid>
                                <Grid item md={3}>
                                    <TextField
                                        name="days"
                                        label='Days'
                                        disabled={modeType === 'view'}
                                        value={data?.days || ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ maxLength: 5 }}
                                        onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('days', e.target.value) : e.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="year"
                                            label="Year"
                                            format="YYYY"
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                            minDate={moment().subtract(40, 'years')}
                                            maxDate={moment().add(1, 'year')}
                                            value={data?.year ? moment(data.year, 'YYYY') : null}
                                            onChange={(date) => { onFieldChange('year', moment(date).format('YYYY')); }}
                                            placeholder="Select Year"
                                            inputVariant="outlined"
                                            views={['year']}
                                            error={''}
                                            helperText={''}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={4}>
                                    <TextField
                                        name='cost'
                                        label='Cost (USD)'
                                        disabled={modeType === 'view'}
                                        value={data?.cost || ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ maxLength: 15 }}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">$</InputAdornment>),
                                        }}
                                        onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('cost', e.target.value) : e.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                    />
                                </Grid></> : null}  
                            <Grid item md={4}>
                                <TextField
                                    name='escalation'
                                    label='Escalation (%)'
                                    disabled={modeType === 'view'}
                                    value={data?.escalation || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => regexConstants.percantageRegExp.test(e.target.value) ? onFieldChange('escalation', e.target.value) : e.preventDefault()}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4} >
                                <Autocomplete
                                    options={(categoryInfo || []).filter((item) => item.id !== data?.category?.id)}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="category"
                                    disabled={modeType === 'view'}
                                    value={data?.category || null}
                                    disableClearable={true}
                                    onChange={(e, value) => { onFieldChange('category', value); }}
                                    renderInput={params => <TextField placeholder={'Please select Category'}  {...params} label={'Category'} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            {!data?.is_llp_event ?
                            <Grid item md={4}>
                                    <TextField
                                        name='ground_time'
                                        label='Ground Time (Days)'
                                        disabled={modeType === 'view'}
                                        value={data?.ground_time || ''}
                                        fullWidth
                                        margin="normal"
                                        inputProps={{ maxLength: 10 }}
                                        onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('ground_time', e.target.value) : e.preventDefault()}
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                    />
                                </Grid>:null}
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            {titanAviInstance ? <Grid item md={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={data?.show_in_ops || false}
                                            onChange={(e) => onFieldChange('show_in_ops', e.target.checked)}
                                            disabled={modeType === 'view'}
                                            name="showInOpsReport"
                                            color="primary"
                                            size="small"
                                        />
                                    }
                                    label={
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            Show in OPS Report
                                            <Tooltip title="When checked, this maintenance program will be included in the OPS Report." arrow>
                                                <InfoIcon color='primary' fontSize='small' style={{ marginLeft: '5px' }} />
                                            </Tooltip>
                                        </span>
                                    }
                                />
                            </Grid> : null}
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Shop Visit Events', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Shop Visit Events form` }) }} color='primary' size='small' variant='outlined'>{modeType === 'view' ? 'Close' : 'Cancel'}</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditSvEvents(); trackActivity('Console Management', { page_title: 'Config Data : Shop Visit Events', item_type: 'Save Button ', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Shop Visit Events form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) =>
                <ErrorPopUp
                    toggleModalFn={() => setError({ modal: false, data: null })}
                    modal={error.modal}
                    error={item} />)}
        </>
    )
}

export default AddEditSvEvents